import axios from "axios"

const searchMovies = async ({
    title,
    language,
    country
}, callbackError) => {
    try {
        const response = await axios.request({
            method: 'GET',
            url: "https://" + process.env.REACT_APP_X_RAPID_API_HOST + "/search/title",
            params: {
                title: title,
                country: country,
                show_type: 'all',
                output_language: language
            },
            headers: {
                'X-RapidAPI-Key': process.env.REACT_APP_X_RAPID_API_KEY,
                'X-RapidAPI-Host': process.env.REACT_APP_X_RAPID_API_HOST
            }
        });
        return response.data.result
    } catch (error) {
        callbackError(error);
    }
}

const getDetailsMovies = async (tmdbId, callbackError) => {
    try {
        const response = await axios.request({
            method: 'GET',
            url: `${process.env.REACT_APP_THEMOVIEDB_HOST}/movie/${tmdbId}`,
            params: {
                api_key: process.env.REACT_APP_THEMOVIEDB_API
            }
        });
        return response.data
    } catch (error) {
        callbackError(error);
    }
}

export {
    searchMovies,
    getDetailsMovies
}
